import { create } from 'zustand';
import { SceneObject } from '../types';

interface CreatorStore {
  objects: SceneObject[];
  setObjects: (objects: SceneObject[] | ((prev: SceneObject[]) => SceneObject[])) => void;
}

export const useCreatorStore = create<CreatorStore>((set) => ({
  objects: [
    {
      id: '1',
      type: 'torus',
      position: [0, 0, 0],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      material: {
        type: ['standard'],
        color: '#ff69b4',
        roughness: 0.5,
        metalness: 0.5,
        emissive: '#000000',
        emissiveIntensity: 0,
        ambientOcclusion: 1,
      },
      animation: [],
      animationSpeed: 1,
    } as any
  ],
  setObjects: (updater) => set((state) => ({ 
    objects: typeof updater === 'function' ? updater(state.objects) : updater 
  })),
}));
